<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
<g>
	<g>
		<path d="M511.999,87.804c0-0.056-0.007-0.112-0.009-0.169c-0.006-0.223-0.019-0.443-0.045-0.661c-0.01-0.08-0.025-0.16-0.037-0.24
			c-0.03-0.201-0.067-0.399-0.113-0.593c-0.018-0.077-0.038-0.153-0.059-0.23c-0.058-0.211-0.124-0.418-0.2-0.622
			c-0.014-0.039-0.023-0.079-0.038-0.117L491.153,33.09c-2.051-5.248-7.018-8.64-12.653-8.64h-37.044
			c-4.038,0-7.311,3.273-7.311,7.311c0,4.038,3.273,7.311,7.311,7.311h36.336l16.191,41.449H340.909l-9.591-41.449h56.533
			c4.038,0,7.311-3.273,7.311-7.311c0-4.038-3.273-7.311-7.311-7.311h-65.729h-73.667H92.076c-5.636,0-10.602,3.392-12.653,8.642
			l-20.345,52.08c-0.015,0.039-0.023,0.079-0.038,0.117c-0.076,0.203-0.142,0.41-0.2,0.622c-0.021,0.077-0.041,0.153-0.059,0.23
			c-0.046,0.195-0.083,0.393-0.113,0.593c-0.012,0.08-0.027,0.16-0.037,0.24c-0.025,0.218-0.039,0.438-0.045,0.661
			c-0.001,0.056-0.008,0.112-0.009,0.169c0,0.009-0.001,0.018-0.001,0.027v107.41c0,4.038,3.273,7.311,7.311,7.311
			c4.038,0,7.311-3.273,7.311-7.311V95.143H228.17v111.128c0,4.346,2.56,8.306,6.523,10.089c1.451,0.653,2.996,0.972,4.531,0.972
			c2.656,0,5.283-0.954,7.343-2.78l38.721-34.304l38.721,34.303c3.251,2.883,7.913,3.592,11.876,1.809
			c3.962-1.784,6.522-5.743,6.522-10.089V95.143h154.971v327.923c0,5.246-4.269,9.515-9.515,9.515H353.81
			c0-0.083-0.01-0.166-0.011-0.249c-0.008-0.656-0.032-1.311-0.088-1.961c12.587,3.337,26.036-3.132,31.08-15.502
			c2.653-6.507,2.614-13.657-0.111-20.133c-0.257-0.61-0.54-1.202-0.838-1.785c-0.055-0.107-0.108-0.215-0.163-0.321
			c-0.293-0.556-0.605-1.099-0.934-1.628c-0.064-0.103-0.13-0.203-0.195-0.305c-0.348-0.543-0.709-1.076-1.094-1.589
			c-0.007-0.01-0.015-0.019-0.022-0.028c-0.382-0.507-0.786-0.995-1.203-1.472c-0.076-0.087-0.151-0.175-0.228-0.262
			c-0.413-0.46-0.842-0.905-1.286-1.334c-0.087-0.084-0.175-0.165-0.263-0.247c-0.465-0.437-0.941-0.862-1.437-1.263
			c-0.017-0.013-0.034-0.026-0.051-0.039c-0.488-0.393-0.995-0.765-1.512-1.123c-0.093-0.065-0.185-0.131-0.28-0.195
			c-0.517-0.348-1.047-0.677-1.591-0.99c-0.045-0.026-0.086-0.056-0.132-0.082c3.09-2.674,5.529-6.058,7.117-9.952
			c2.653-6.507,2.614-13.657-0.111-20.134c-2.384-5.667-6.575-10.225-11.943-13.053c-0.767-0.404-1.558-0.773-2.371-1.104
			l-113.787-46.397l52.966-16.394c12.601-3.901,19.698-17.341,15.82-29.958c-1.447-4.71-4.316-8.682-8.022-11.585
			c-5.515-4.321-12.886-6.272-20.196-4.737c-0.035,0.008-0.069,0.014-0.104,0.023c-0.405,0.091-41.009,9.221-83.416,17.49
			c-1.881,0.367-3.714,0.721-5.521,1.069c-1.446,0.278-2.872,0.552-4.271,0.818c-0.402,0.077-0.805,0.153-1.204,0.229
			c-2.47,0.469-4.863,0.918-7.189,1.35c-0.936,0.174-1.864,0.346-2.777,0.514c-53.257,9.811-68.218,9.987-72.37,9.425
			c-0.016-0.002-0.03-0.004-0.046-0.007c-0.063-0.009-0.125-0.018-0.183-0.027c-0.042-0.007-0.081-0.014-0.12-0.02
			c-0.028-0.005-0.058-0.01-0.085-0.014c-0.259-0.047-0.461-0.096-0.617-0.143l-1.198-0.488l1.493-3.661
			c1.468-3.6,1.446-7.556-0.061-11.139c-0.377-0.896-0.836-1.742-1.368-2.53c-1.596-2.363-3.853-4.203-6.553-5.304l-39.268-16.011
			c-3.599-1.469-7.556-1.446-11.139,0.061c-3.584,1.507-6.365,4.32-7.833,7.919L1.077,346.076
			c-3.03,7.431,0.551,15.941,7.982,18.972l39.269,16.012c1.793,0.731,3.648,1.077,5.475,1.077c5.743,0,11.197-3.422,13.496-9.059
			l0.361-0.885l9.054,3.691c0.005,0.002,0.01,0.005,0.016,0.007c8.66,3.531,16.639,8.569,23.545,14.821
			c1.256,1.137,2.476,2.314,3.659,3.529c1.183,1.215,2.327,2.469,3.432,3.759c0.552,0.645,1.095,1.3,1.626,1.963
			c10.063,12.548,23.255,22.391,38.148,28.464l10.186,4.153H82.714c-5.246,0-9.515-4.269-9.515-9.515v-18.499
			c0-4.038-3.273-7.311-7.311-7.311s-7.311,3.273-7.311,7.311v18.499c0,13.309,10.827,24.137,24.137,24.137h110.473l94.181,38.402
			c3.242,1.322,6.596,1.949,9.899,1.948c10.379,0,20.237-6.185,24.392-16.374c1.704-4.179,2.251-8.547,1.792-12.746
			c4.899,0.703,9.978,0.058,14.582-1.93c4.679-2.021,8.557-5.24,11.311-9.301h138.52c13.309,0,24.137-10.827,24.137-24.137V87.832
			C512,87.822,511.999,87.814,511.999,87.804z M254.267,39.072h62.042l9.591,41.449h-81.224L254.267,39.072z M229.668,80.521H76.593
			l16.191-41.449h146.475L229.668,80.521z M327.787,198.362h-0.001l-35.162-31.15c-2.091-1.852-4.713-2.778-7.334-2.778
			c-2.622,0-5.245,0.926-7.336,2.778l-35.161,31.15V95.143h84.994V198.362z M53.785,367.494l-39.143-15.96l47.966-117.635
			l39.143,15.961L53.785,367.494z M345.87,411.615l-8.391-3.422c-0.004-0.002-0.008-0.003-0.012-0.005
			c-0.003-0.001-0.006-0.003-0.009-0.004c-0.001,0-0.002-0.001-0.003-0.001l-87.386-35.631c-3.738-1.524-8.005,0.27-9.53,4.01
			c-1.525,3.739,0.27,8.006,4.01,9.531l87.388,35.632c0.365,0.149,0.718,0.314,1.059,0.495c0.096,0.051,0.185,0.113,0.279,0.166
			c0.24,0.136,0.481,0.272,0.708,0.423c0.109,0.073,0.209,0.157,0.315,0.233c0.201,0.144,0.406,0.286,0.596,0.442
			c0.115,0.094,0.219,0.199,0.33,0.297c0.17,0.151,0.344,0.297,0.504,0.457c0.111,0.11,0.21,0.231,0.316,0.345
			c0.147,0.158,0.298,0.313,0.436,0.479c0.105,0.127,0.197,0.262,0.297,0.393c0.125,0.164,0.255,0.325,0.37,0.495
			c0.097,0.142,0.18,0.292,0.27,0.437c0.104,0.168,0.214,0.333,0.309,0.506c0.086,0.156,0.158,0.319,0.237,0.478
			c0.084,0.171,0.175,0.339,0.251,0.514c0.073,0.168,0.132,0.342,0.197,0.513c0.066,0.173,0.138,0.343,0.196,0.519
			c0.058,0.177,0.102,0.358,0.151,0.537c0.049,0.177,0.104,0.351,0.145,0.53c0.041,0.181,0.067,0.365,0.1,0.547
			s0.071,0.362,0.095,0.546c0.024,0.184,0.033,0.37,0.048,0.555c0.015,0.186,0.037,0.371,0.043,0.557
			c0.006,0.183-0.003,0.368-0.005,0.552c-0.002,0.19,0.001,0.38-0.011,0.571c-0.011,0.181-0.038,0.362-0.058,0.543
			c-0.021,0.195-0.037,0.39-0.069,0.584c-0.029,0.178-0.074,0.355-0.111,0.533c-0.042,0.197-0.077,0.394-0.13,0.59
			c-0.046,0.173-0.108,0.345-0.163,0.517c-0.062,0.196-0.119,0.392-0.192,0.585c-0.062,0.133-0.123,0.267-0.18,0.402
			c-0.013,0.031-0.02,0.063-0.032,0.093c-1.142,2.637-3.25,4.732-6.003,5.921c-3.03,1.307-6.499,1.353-9.519,0.121l-15.483-6.313
			c-0.072-0.029-0.145-0.049-0.217-0.076c-0.073-0.033-0.142-0.071-0.216-0.101l-71.076-28.981c-3.741-1.524-8.006,0.27-9.53,4.01
			c-1.525,3.739,0.27,8.006,4.009,9.531l71.076,28.981c0.076,0.031,0.153,0.053,0.23,0.081c0.069,0.03,0.133,0.067,0.204,0.095
			c5.965,2.433,8.84,9.265,6.408,15.23c-2.433,5.967-9.262,8.843-15.23,6.408l-95.495-38.938c-0.004-0.002-0.008-0.004-0.012-0.006
			l-44.72-18.235c-7.872-3.21-15.182-7.665-21.635-13.146c-3.872-3.289-7.435-6.946-10.627-10.926
			c-3.145-3.921-6.595-7.578-10.307-10.939c-8.167-7.393-17.602-13.35-27.841-17.526c-0.001,0-0.002-0.001-0.003-0.001l-9.066-3.696
			l18.057-44.285l17.064-41.849l1.259,0.513c1.185,0.483,2.875,1.169,7.423,1.341c5.682,0.257,15.082-0.336,31.922-2.715
			c11.455-1.618,25.506-3.958,41.909-6.976c0.404-0.074,0.805-0.148,1.213-0.223c0.767-0.142,1.542-0.286,2.32-0.43
			c0.605-0.112,1.213-0.226,1.826-0.341c0.698-0.131,1.399-0.262,2.105-0.395c0.749-0.141,1.507-0.284,2.269-0.429
			c0.61-0.116,1.219-0.231,1.835-0.348c0.929-0.177,1.874-0.358,2.822-0.54c0.488-0.094,0.971-0.186,1.463-0.28
			c1.452-0.28,2.923-0.564,4.421-0.855c42.261-8.22,83.051-17.369,84.884-17.781c0.183-0.038,0.366-0.06,0.549-0.087
			c4.696-0.695,9.297,2.021,10.644,6.403c0.473,1.54,0.528,3.111,0.23,4.589c-0.655,3.253-3.019,6.06-6.398,7.105l-72.482,22.434
			c-2.951,0.914-5.009,3.581-5.142,6.667c-0.134,3.085,1.684,5.922,4.544,7.088l132.704,54.111c2.89,1.178,5.148,3.411,6.358,6.288
			c1.21,2.877,1.228,6.053,0.049,8.942c-1.179,2.89-3.411,5.148-6.288,6.358c-1.438,0.604-2.951,0.91-4.466,0.919
			c-0.022,0-0.044-0.003-0.066-0.003c-0.356,0-0.711-0.014-1.066-0.047c-0.105-0.01-0.209-0.032-0.314-0.044
			c-0.271-0.033-0.542-0.064-0.811-0.116c-0.17-0.033-0.338-0.083-0.507-0.123c-0.202-0.048-0.405-0.089-0.605-0.148
			c-0.207-0.061-0.41-0.142-0.614-0.215c-0.162-0.058-0.327-0.106-0.487-0.171l-87.396-35.636c-3.739-1.525-8.005,0.27-9.53,4.01
			c-1.525,3.739,0.27,8.006,4.01,9.531l105.955,43.203c0.723,0.294,1.406,0.655,2.043,1.075c1.911,1.26,3.408,3.055,4.315,5.213
			c1.059,2.517,1.205,5.263,0.435,7.846c-0.11,0.369-0.239,0.735-0.386,1.096c-0.152,0.373-0.321,0.734-0.506,1.082
			c-0.431,0.81-0.956,1.542-1.542,2.209c-0.364,0.414-0.753,0.8-1.167,1.154c-0.066,0.056-0.126,0.12-0.193,0.174
			c-2.668,2.182-6.235,3.12-9.72,2.416c-0.707-0.143-1.41-0.346-2.102-0.628L345.87,411.615z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
